import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmumbai() {



  const cardData =
  {
    keyword: 'Cab Service in Mumbai ',
    heading: 'Shambhu Cabs: Cab Service in Mumbai',
    headingDescription: 'Shambhu Cabs offers professional and reliable Cab Service in Mumbai, providing safe, comfortable, and hassle-free transportation for daily commuters, corporate travelers, families, and tourists across the city. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures smooth travel with well-maintained vehicles and spacious seating. With flexible hourly, daily, and airport transfer options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes city travel convenient and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted cab services in Mumbai for travelers seeking comfort, safety, punctuality, and a reliable urban travel experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Cab Near Me Mumbai",
    "description": "Cab Near Me Mumbai helps passengers quickly find nearby cabs for instant pickup anywhere in the city. With a focus on convenience and speed, this service ensures minimal waiting times, professional drivers, and safe, well-maintained vehicles for short trips or urgent travel needs."
  },
  {
    "name": "Best Cab Service Mumbai",
    "description": "Best Cab Service Mumbai provides high-quality transportation across the city with a commitment to punctuality, safety, and comfort. The fleet includes sedans, SUVs, and AC cabs suitable for families, corporate clients, and solo travelers."
  },
  {
    "name": "Mumbai Local Cabs",
    "description": "Mumbai Local Cabs specialize in city travel within Mumbai, offering efficient point-to-point rides, airport transfers, and daily commuting options. Drivers are familiar with local traffic patterns, ensuring faster routes and timely arrivals."
  },
  {
    "name": "Affordable Cabs in Mumbai",
    "description": "Affordable Cabs in Mumbai provides budget-friendly options without compromising on safety or comfort. Ideal for daily commuters, students, or families, these cabs offer transparent pricing and reliable service across the city."
  },
  {
    "name": "24×7 Cab Service Mumbai",
    "description": "24×7 Cab Service Mumbai ensures round-the-clock availability for pickups and drop-offs. Travelers can rely on punctual service, professional drivers, and safe rides at any time of day or night."
  },
  {
    "name": "AC Cab Mumbai",
    "description": "AC Cab Mumbai provides comfortable air-conditioned rides throughout the city, ideal for summer travel, business trips, and family outings. Vehicles are regularly sanitized and maintained for a pleasant experience."
  },
  {
    "name": "Mumbai Point-to-Point Taxi",
    "description": "Mumbai Point-to-Point Taxi offers direct and convenient city rides from one location to another. Perfect for office commutes, airport transfers, or shopping trips, this service ensures quick pickups and smooth travel."
  },
  {
    "name": "Mumbai Pickup Drop Cab",
    "description": "Mumbai Pickup Drop Cab provides door-to-door service for passengers, whether traveling for work, school, or personal errands. Reliable drivers, flexible schedules, and well-maintained vehicles guarantee a hassle-free experience."
  },
  {
    "name": "Fast Cab Service Mumbai",
    "description": "Fast Cab Service Mumbai specializes in quick and efficient city travel. Experienced drivers take the fastest routes to avoid traffic delays, ensuring passengers reach their destinations promptly and comfortably."
  },
  {
    "name": "City Ride Cab Mumbai",
    "description": "City Ride Cab Mumbai offers smooth and convenient rides within Mumbai, suitable for short trips, business meetings, and family outings. The service emphasizes comfort, reliability, and safety for all passengers."
  },
  {
    "name": "Safe Cab Service Mumbai",
    "description": "Safe Cab Service Mumbai prioritizes passenger safety with GPS-enabled vehicles, trained drivers, and adherence to all traffic rules. Ideal for families, solo travelers, and senior citizens seeking secure travel across the city."
  },
  {
    "name": "Sadar Bazaar Cab Mumbai",
    "description": "Sadar Bazaar Cab Mumbai caters to travelers commuting to and from the bustling Sadar Bazaar area. With local knowledge and experienced drivers, this service ensures timely pickups, safe travel, and hassle-free navigation through busy streets."
  },
  {
    "name": "Mumbai Suburban Cab Service",
    "description": "Mumbai Suburban Cab Service provides reliable transportation across suburban areas, connecting residential zones with business hubs, shopping centers, and educational institutions. This service is ideal for daily commuters seeking comfort and punctuality."
  },
  {
    "name": "Family Cab Mumbai",
    "description": "Family Cab Mumbai offers spacious and comfortable vehicles suitable for family outings, airport transfers, and shopping trips. Prioritizing safety and convenience, this service ensures an enjoyable travel experience for all family members."
  },
  {
    "name": "Premium Cab Service Mumbai",
    "description": "Premium Cab Service Mumbai delivers luxury transportation with high-end sedans and SUVs, professional chauffeurs, and impeccable service. Perfect for VIP clients, corporate executives, or special occasions requiring comfort and style."
  },
  {
    "name": "Online Cab Booking Mumbai",
    "description": "Online Cab Booking Mumbai allows passengers to reserve cabs conveniently via digital platforms. With instant confirmation, secure payments, and multiple vehicle options, travelers can enjoy a hassle-free booking experience from anywhere in the city."
  },
  {
    "name": "Mumbai Car with Driver",
    "description": "Mumbai Car with Driver provides chauffeur-driven cars for corporate clients, families, and tourists. Offering flexibility, professionalism, and comfort, this service ensures smooth travel for both short city trips and long journeys from Mumbai."
  }
],

"tableData": [
  ["Cab Near Me Mumbai", "Best Cab Service Mumbai"],
  ["Mumbai Local Cabs", "Affordable Cabs in Mumbai"],
  ["24×7 Cab Service Mumbai", "AC Cab Mumbai"],
  ["Mumbai Point-to-Point Taxi", "Mumbai Pickup Drop Cab"],
  ["Fast Cab Service Mumbai", "City Ride Cab Mumbai"],
  ["Safe Cab Service Mumbai", "Sadar Bazaar Cab Mumbai"],
  ["Mumbai Suburban Cab Service", "Family Cab Mumbai"],
  ["Premium Cab Service Mumbai", "Online Cab Booking Mumbai"],
  ["Mumbai Car with Driver", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable and convenient cab services in Mumbai, perfect for daily commutes, airport transfers, and city travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a comfortable and safe journey across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with all major routes in Mumbai, ensuring timely, smooth, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and upfront pricing—fuel, tolls, and driver allowances included—making your cab service in Mumbai stress-free and affordable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for City Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans suited for your Mumbai city travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your city travel in Mumbai comfortable and worry-free."
  }
]































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services across Mumbai for local travel, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a cab in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free booking.',
  },
  {
    question: 'What types of vehicles are available for cab service in Mumbai?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars suitable for both individual and group travel within Mumbai.',
  },
  {
    question: 'Are drivers experienced for cab services in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-versed with the Mumbai city routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for cab service in Mumbai?',
    answer: 'Absolutely. You can select any pickup point and drop-off location anywhere within Mumbai according to your convenience.',
  },
  {
    question: 'Is the cab service in Mumbai available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock cab services in Mumbai to meet your travel needs at any time.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab services in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene and safety protocols to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for cab service in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the cab journey in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your cab journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehra',
    feedback: 'Shambhu Cabs made traveling within Mumbai very convenient. The driver was professional, and the car was very clean.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kapoor',
    feedback: 'Reliable and timely cab service in Mumbai. Highly recommend Shambhu Cabs for local travel and airport transfers.',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/cab-service-mumbai.jpg",
  "description": "Shambhu Cabs offers safe, reliable, and affordable cab service in Mumbai. Book local point-to-point taxis, AC cabs, family rides, or premium cars with driver. Available 24×7 for fast pickups, suburban travel, online bookings, and convenient city rides across Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "350",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/cab-service-in-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Service in Mumbai | Local & Premium Cabs | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book reliable and affordable cab service in Mumbai with Shambhu Cabs. Local point-to-point taxis, AC cabs, family rides, premium cars with driver, 24×7 availability, fast pickups, online booking, and suburban travel across Mumbai."
  />

  <meta
    name="keywords"
    content="Cab Near Me Mumbai, Best Cab Service Mumbai, Mumbai Local Cabs, Affordable Cabs in Mumbai, 24×7 Cab Service Mumbai, AC Cab Mumbai, Mumbai Point-to-Point Taxi, Mumbai Pickup Drop Cab, Fast Cab Service Mumbai, City Ride Cab Mumbai, Safe Cab Service Mumbai, Sadar Bazaar Cab Mumbai, Mumbai Suburban Cab Service, Family Cab Mumbai, Premium Cab Service Mumbai, Online Cab Booking Mumbai, Mumbai Car with Driver"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmumbai;